module.exports = __webpack_public_path__ + "images/fill-blank-selection.webp";